// Shows form on contact form preference button press and sets required on related inputs

window.addEventListener('load', event => {
    let formPanels = document.querySelectorAll('.form-panel-contact');
    for (let formPanel of formPanels) {
        let formContainer = formPanel.querySelector('[data-freeform-container]');
        let formVisibilityContainer = formPanel.querySelector('[data-tw-toggle-form-visibility]');
        let formButtons = formPanel.querySelectorAll('button[data-form-selector]');
        let formHeading = formPanel.querySelector('h2');

        let preferredContactMethodInput = formPanel.querySelector('input[name="preferredContactMethod"]');
        let emailInput = formPanel.querySelector('input[name="email"]');
        let phoneInput = formPanel.querySelector('input[name="mobile"]');

        for (let button of formButtons) {
            let formType = button.dataset.formtype;

            button.addEventListener('click', event => {
                for (let button of formButtons) {
                    button.dataset.open = 'false';
                }

                button.dataset.open = 'true';

                if (preferredContactMethodInput) {
                    preferredContactMethodInput.value = formType;
                }

                formVisibilityContainer.dataset.open = 'true';

                if (preferredContactMethodInput.value === 'Call') {
                    phoneInput.closest('div').querySelector('label').classList.add('freeform-required');
                    phoneInput.setAttribute('required', 'true');
                    emailInput.closest('div').querySelector('label').classList.remove('freeform-required');
                    emailInput.removeAttribute('required');
                    if (formHeading) {
                        formHeading.innerText = "We'll give you a call";
                    }
                } else {
                    emailInput.closest('div').querySelector('label').classList.add('freeform-required');
                    emailInput.setAttribute('required', 'true');
                    phoneInput.closest('div').querySelector('label').classList.remove('freeform-required');
                    phoneInput.removeAttribute('required');
                    if (formHeading) {
                        formHeading.innerText = "We'll send you an email";
                    }
                }
            });
        }
    }
});